import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { HelpPage } from './pages/HelpPage';
import { LiveEventMonitor } from './pages/LiveEventMonitor';
import { DeliveryLogPage } from './pages/DeliveryLogPage';
import { MockPartnerMonitor } from './pages/MockPartnerMonitor';
import { RabbitMQPage } from './pages/RabbitMQPage';
import { UsersPage } from './pages/UsersPage';
import { SourceSystemsPage } from './pages/SourceSystemsPage';
import { NovaAccountsPage } from './pages/NovaAccountsPage';
import { TenantsPage } from './pages/TenantsPage';
import { PartnersPage } from './pages/PartnersPage';
import { PartnerDetailPage } from './pages/PartnerDetailPage';
import { PartnerDashboard } from './pages/PartnerDashboard';
import { PartnerTestEvents } from './pages/PartnerTestEvents';
import { AuditLogPage } from './pages/AuditLogPage';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ToastContainer } from './components/Toast';
import { useAuthStore } from './stores/authStore';
import { useEnvironmentStore } from './stores/environmentStore';

function App() {
  const initialize = useAuthStore((state) => state.initialize);
  const loadEnvironment = useEnvironmentStore((state) => state.load);

  useEffect(() => {
    initialize();
    loadEnvironment();
  }, [initialize, loadEnvironment]);

  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Integration Operations */}
        <Route path="/" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
        <Route path="/live-monitor" element={<ProtectedRoute><Layout fullWidth><LiveEventMonitor /></Layout></ProtectedRoute>} />
        <Route path="/delivery-log" element={<ProtectedRoute><Layout fullWidth><DeliveryLogPage /></Layout></ProtectedRoute>} />
        <Route path="/mock-partner-monitor" element={<ProtectedRoute><Layout fullWidth><MockPartnerMonitor /></Layout></ProtectedRoute>} />
        <Route path="/configuration" element={<Navigate to="/configuration/accounts" replace />} />
        <Route path="/configuration/sources" element={<ProtectedRoute><Layout><SourceSystemsPage /></Layout></ProtectedRoute>} />
        <Route path="/configuration/accounts" element={<ProtectedRoute><Layout><NovaAccountsPage /></Layout></ProtectedRoute>} />
        <Route path="/configuration/tenants" element={<ProtectedRoute><Layout><TenantsPage /></Layout></ProtectedRoute>} />
        <Route path="/configuration/partners" element={<ProtectedRoute><Layout><PartnersPage /></Layout></ProtectedRoute>} />
        <Route path="/configuration/partners/:id" element={<ProtectedRoute><Layout><PartnerDetailPage /></Layout></ProtectedRoute>} />
        <Route path="/rabbitmq" element={<ProtectedRoute><Layout><RabbitMQPage /></Layout></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><Layout><UsersPage /></Layout></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute><Layout fullWidth><AuditLogPage /></Layout></ProtectedRoute>} />

        {/* Partner-scoped surfaces */}
        <Route path="/partner" element={<ProtectedRoute><Layout><PartnerDashboard /></Layout></ProtectedRoute>} />
        <Route path="/partner/test-events" element={<ProtectedRoute><Layout><PartnerTestEvents /></Layout></ProtectedRoute>} />

        {/* Utility */}
        <Route path="/help" element={<ProtectedRoute><Layout><HelpPage /></Layout></ProtectedRoute>} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
